export function fromGlobalId(val: string) {
  const [model, id] = atob(val).split(':')
  return {model, id}
}

export function intFromGlobalId(val: string) {
  const {model, id} = fromGlobalId(val)
  return {model, id: parseInt(id, 10)}
}

export function toGlobalId(model: string, id: number | string) {
  return btoa(`${model}:${id}`)
}
